export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH';
export const FETCH_POST = 'FETCH_POST';
export const LIKE = 'LIKE';
export const END_LOADING = 'END_LOADING';
export const START_LOADING = 'START_LOADING';
export const COMMENT = 'COMMENT';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const FETCH_SINGLE_USER_ALL = 'FETCH_SINGLE_USER_ALL';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_CONTRIBUTE = 'UPDATE_CONTRIBUTE';
export const FETCH_CONTRIBUTION_BY_ID = 'FETCH_CONTRIBUTION_BY_ID';